<template>
  <div>
    <v-row>
      <template v-for="(item, i) of subDataReturn">
        <v-col :key="i" cols="6" :md="item.is_main_partner === 1 ? 6 : 4">
          <PartnerHighlightCard
                  v-if="item.is_main_partner === 1"
                  :img="item.image_path"
                  @onPress="openLink(item.url)"
          />
          <PartnerCard
                  v-else
                  :img="item.image_path"
                  @onPress="openLink(item.url)"
          />
        </v-col>
      </template>
    </v-row>
    <v-row class="mt-4 mb-8">
      <v-col>
        <GreenButton v-if="aboutPartner.length > items" label="load more" @click.native="loadMoreHandler" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PartnerCard from "../cards/PartnerCard";
import PartnerHighlightCard from "../cards/PartnerHighlightCard";
import GreenButton from "../buttons/GreenButton";
import { mapState } from 'vuex';

export default {
  components: {
    PartnerCard,
    PartnerHighlightCard,
    GreenButton
  },
  data: () => ({
    items: 5
  }),
  computed: {
    ...mapState({
      aboutPartner: state => state.About.partner,
    }),
    subDataReturn: function () {
      return this.aboutPartner.slice(0, this.items);
    }
  },
  methods: {
    loadMoreHandler() {
      if (this.aboutPartner.length > this.items) {
          this.items += 3;
      }
    },
    openLink(link) {
      if (link) {
        window.open(link);
      }
    }
  }
};
</script>

<style>
</style>
